import { User } from '../__generated__/graphql'

const TEAM_ADMIN_ROLE = 'team_admin'

export const isTeamMember = (user?: User | null) =>
  !!user && user.roles.length > 0 && !user.roles.includes(TEAM_ADMIN_ROLE)

export const isTeamMemberWithoutLabPlus = (user?: User | null) =>
  isTeamMember(user) && !user?.labSubscriptionActive
